import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { IntegrationsApiAdapter } from '../adapters/IntegrationsApiAdapter';

export const INTEGRATIONS_QUERY_KEY = 'integrations';

export const useIntegrations = () => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new IntegrationsApiAdapter(httpClient);

  return useQuery({
    queryKey: [INTEGRATIONS_QUERY_KEY],
    queryFn: () => adapter.getIntegrations(),
    staleTime: 2 * 60 * 1000,
  });
};
